import { RouteRecordRaw } from "vue-router";
import { AuthRouteNames } from "@/constants/routes";

const authRoutes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: AuthRouteNames.LOGIN,
        component: () => import("@/views/auth/login/LoginEsenda.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
    {
        path: "/unauthorised-access",
        name: AuthRouteNames.UNAUTHORISED_ACCESS,
        component: () => import("@/views/auth/UnauthorisedAccess.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
    {
        path: "/:catchAll(.*)",
        name: AuthRouteNames.NOT_FOUND,
        component: () => import("@/views/auth/404.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
];

export default authRoutes.map((route) => {
    return { ...route };
});
